function initQuickShop() {
  // Loaded globally from theme.liquid; runs again on theme-editor section
  // loads. Per-element flags keep re-runs (and stray duplicate script loads,
  // e.g. Shoplift-generated templates) from double-binding live cards.
  const metalOptions = document.querySelectorAll('[data-quick-shop] .swatch-container input');
  metalOptions.forEach(function(option) {
    if (option.dataset.quickShopBound) return;
    option.dataset.quickShopBound = 'true';
    option.addEventListener('click', function() {
      const optionContainer = option.closest('.card-wrapper');
      const varScript = optionContainer.querySelector('script[type="application/json"]');
      const varData = JSON.parse(varScript.innerHTML);
      const selectedMetalOption = option;
      const selectedOptionValue = selectedMetalOption.value;
      const matchingVariant = varData.find(variant => variant.options.includes(selectedOptionValue));
      if (!matchingVariant) {
        console.error('Matching variant not found.');
        return;
      }
      const cardImgDesktop = optionContainer.querySelector('div.card__inner div.media img');
      const cardImgMobile = optionContainer.querySelector('div.card__inner div.mobile-swiper img');
      // Before the first swap, remember the card's original (product-level)
      // images — the fallback for variants with no image of their own.
      [cardImgDesktop, cardImgMobile].forEach(function(img) {
        if (img && !img.dataset.originalSrc) {
          img.dataset.originalSrc = img.src;
          img.dataset.originalSrcset = img.srcset;
        }
      });
      if (matchingVariant.featured_image) {
        const varImg = matchingVariant.featured_image.src;
        const mobileImg = varImg.replace(/(\.jpg|\.png)(\?.*)?$/, '_260x360_crop_center$1$2');
        if (cardImgDesktop) {
          cardImgDesktop.src = `${varImg}?${new Date().getTime()}`;
          cardImgDesktop.srcset = `${varImg}?${new Date().getTime()}`;
        } else {
          console.error('Desktop image element not found.');
        }
        if (cardImgMobile) {
          cardImgMobile.src = `${mobileImg}?${new Date().getTime()}`;
          cardImgMobile.srcset = `${mobileImg}?${new Date().getTime()}`;
        } else {
          console.error('Mobile image element not found.');
        }
      } else {
        [cardImgDesktop, cardImgMobile].forEach(function(img) {
          if (img) {
            img.src = img.dataset.originalSrc;
            img.srcset = img.dataset.originalSrcset;
          }
        });
      }
      const varPrice = matchingVariant.price;
      const formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(varPrice / 100);
      const priceContainer = optionContainer.querySelector('span.price-item.price-item--regular');
      if (priceContainer) {
        priceContainer.textContent = formattedPrice;
      } else {
        console.error('Price container not found.');
      }
    });
  });

  const shopNowBtns = document.querySelectorAll('[data-quick-shop] .shop__now button');
  shopNowBtns.forEach(function(btn) {
    if (btn.dataset.quickShopBound) return;
    btn.dataset.quickShopBound = 'true';
    btn.addEventListener('click', function(event) {
      event.preventDefault();

      if(!!btn.getAttribute('data-product-handle')) {
        window.location.href = '/products/' + btn.getAttribute('data-product-handle');
        return;
      }
      const optionContainer = btn.closest('.card-wrapper');
      const varScript = optionContainer.querySelector('script[type="application/json"]');
      const varData = JSON.parse(varScript.innerHTML);
      // No-metal products render no swatch inputs; their first option is the one to offer.
      const selectedMetalOption = optionContainer.querySelector('.swatch-container input:checked');
      const optionType = (selectedMetalOption && btn.getAttribute('data-product-option-1')) || btn.getAttribute('data-product-option-0');
      const optionElements = createRelatedOptionElements(event, varData, selectedMetalOption, optionType);

      // If null, single variant was auto-added to cart - no UI needed
      if (!optionElements) return;

      if (window.matchMedia("(max-width: 768px)").matches) {
        // Store product data before moving to overlay (for bundle mode)
        const gridItem = btn.closest('.card-wrapper');
        const productTitle = gridItem.querySelector('.card-information__text')?.textContent?.trim() || '';
        const productImage = gridItem.querySelector('.card__inner img')?.src || '';
        const variantScript = gridItem.querySelector('script[type="application/json"]');
        const variantData = variantScript ? JSON.parse(variantScript.innerHTML) : [];

        optionElements.dataset.productInfo = JSON.stringify({
          title: productTitle,
          image: productImage,
          variantData: variantData
        });

        // Create the overlay element
        const overlay = document.createElement('div');
        overlay.className = 'overlay';
        document.body.appendChild(overlay);

        // Append the option elements to the overlay
        overlay.appendChild(optionElements);

        // Create the close button
        const closeBtn = document.createElement('button');
        closeBtn.textContent = 'Close';
        closeBtn.className = 'close-options badge';
        closeBtn.addEventListener('click', function() {
          optionElements.remove();
          overlay.remove();
        });

        // Append the close button to the option elements
        optionElements.appendChild(closeBtn);
      } else {
        const productCard = btn.closest('.card-wrapper').querySelector('.card--product');
        productCard.appendChild(optionElements);

        // Add close button in bundle mode on desktop
        if (window.bundleModeActive) {
          const closeBtn = document.createElement('button');
          closeBtn.textContent = '×';
          closeBtn.className = 'close-options-desktop';
          closeBtn.setAttribute('aria-label', 'Close options');
          closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            optionElements.remove();
          });
          optionElements.appendChild(closeBtn);
        }
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuickShop);
} else {
  initQuickShop();
}
document.addEventListener('shopify:section:load', initQuickShop);
// Filters, sorting and Load more replace or extend the product grid without a
// section event; the grid announces that itself.
document.addEventListener('product-grid:updated', initQuickShop);

function createRelatedOptionElements(event, variantData, optionName, optionType) {
  // optionName is null for products without a Metal option — then every
  // variant is a candidate and option position 0 (normally Metal) is offered.
  const matchingVariants = optionName ? variantData.filter(variant => variant.options[0] === optionName.value) : variantData;
  // A lone sold-out variant falls through to the sheet (rendered disabled)
  // instead of a silent failed add-to-cart. Its id comes from the JSON, not
  // the swatch's data-variant-id, which indexes product.variants by metal
  // position and is wrong whenever the product also has sizes.
  if (matchingVariants.length === 1 && matchingVariants[0].available) {
    quickShopATC(event, matchingVariants[0].id);
    return null; // No UI needed for single variant - item already added to cart
  }
  // Metal-only products have nothing beyond position 0 — the sheet then
  // shows the metal itself, which is only reachable when it's sold out
  // (an available lone variant auto-adds above), so it renders disabled.
  const firstPos = optionName && matchingVariants.some(v => v.options.length > 1) ? 1 : 0;
  const optionCount = Math.max(...matchingVariants.map(v => v.options.length)) - firstPos;
  const container = document.createElement('div');
  container.className = 'options-container active slide-in-bottom';
  const optionGroups = Array.from({ length: optionCount }, (_, pos) => {
    pos += firstPos;
    const optionGroup = document.createElement('div');
    optionGroup.className = `option-group option-group-${pos}`;
    const uniqueOptions = [...new Set(matchingVariants.map(v => v.options[pos]).filter(Boolean))];
    const heading = document.createElement('h3');
    heading.textContent = `Select ${optionType}`;
    container.appendChild(heading);
    uniqueOptions.forEach((option, index) => {
      const matchingVariant = matchingVariants.find(v => v.options[pos] === option);
      const sku = matchingVariant.sku;
      const variantId = matchingVariant.id;
      const productTitle = matchingVariant.name.split(' - ')[0];
      const wrapper = document.createElement('div');
      wrapper.className = 'option-wrapper';
      const input = document.createElement('input');
      input.type = 'radio';
      input.id = `option-${sku}-${pos}-${index}`;
      input.name = `${productTitle}`;
      input.value = option;
      input.dataset.variantId = variantId;
      input.dataset.variantAvailable = matchingVariant.available;
      const label = document.createElement('label');
      label.htmlFor = `option-${sku}-${pos}-${index}`;
      label.textContent = option;
      if(matchingVariant.available === false) {
        input.disabled = true;
        input.setAttribute('aria-disabled', true);
        label.classList.add('disabled');
      }
      input.addEventListener('change', quickShopATC);
      wrapper.append(input, label);
      optionGroup.appendChild(wrapper);
    });
    return optionGroup;
  });
  
  async function quickShopATC(event, varId = null){
    event.preventDefault();

    // If bundle mode is active, route to bundle instead of cart
    if (window.bundleModeActive && window.addToBundleCart) {
      if(varId === null) {
        varId = Number(event.srcElement.getAttribute('data-variant-id'))
      }

      // Get product info from the option container
      let optionContainer = event.target.closest('.card-wrapper');
      let productTitle = '';
      let productImage = '';
      let varData = [];

      if (optionContainer) {
        // Desktop: Query from grid item
        productTitle = optionContainer.querySelector('.card-information__text')?.textContent?.trim() || '';
        productImage = optionContainer.querySelector('.card__inner img')?.src || '';
        const varScript = optionContainer.querySelector('script[type="application/json"]');
        varData = varScript ? JSON.parse(varScript.innerHTML) : [];
      } else {
        // Mobile: Retrieve from stored data
        const optionsContainer = event.target.closest('.options-container');
        if (optionsContainer?.dataset.productInfo) {
          const storedInfo = JSON.parse(optionsContainer.dataset.productInfo);
          productTitle = storedInfo.title || '';
          productImage = storedInfo.image || '';
          varData = storedInfo.variantData || [];
        } else {
          console.error('Could not find product data for bundle mode');
          return;
        }
      }

      const selectedVariant = varData.find(v => v.id === varId);

      // Build product data for bundle
      const productData = {
        variantId: varId,
        productTitle: productTitle,
        productHandle: selectedVariant?.handle || '',
        variantTitle: selectedVariant?.title || '',
        price: selectedVariant?.price || 0,
        image: selectedVariant?.featured_image?.src || productImage,
        selectedOptions: {}
      };

      // Extract selected options
      if (selectedVariant && selectedVariant.options) {
        selectedVariant.options.forEach((optionValue, index) => {
          const optionName = selectedVariant.option1 && index === 0 ? 'Metal' :
                            selectedVariant.option2 && index === 1 ? 'Size' :
                            `Option${index + 1}`;
          productData.selectedOptions[optionName] = optionValue;
        });
      }

      // Add to bundle
      window.addToBundleCart(varId, productData);

      // Close quick-shop UI
      const optionsContainer = event.target.closest('.options-container');
      if (optionsContainer) {
        optionsContainer.remove();
      }
      const overlay = document.querySelector('.overlay');
      if (overlay) {
        overlay.remove();
      }

      return;
    }

    // Normal quick-shop flow
    const quickShopOrigin = window.location.pathname;
    let quickShopSource = null;
    if (quickShopOrigin.includes('/collections/')) {
      quickShopSource = 'Collection: ' + quickShopOrigin.split('/collections/')[1];
    } else if (quickShopOrigin.includes('/pages/')) {
      quickShopSource = 'Page: ' + quickShopOrigin.split('/pages/')[1];
    } else if (quickShopOrigin.includes('/search')) {
      const searchQuery = window.location.search.split('=')[1].split('&')[0];
      quickShopSource = 'Search: ' + decodeURIComponent(searchQuery).replace(/\+/g, ' ');
    }
    if(varId === null) {
      varId = Number(event.srcElement.getAttribute('data-variant-id'))
    }
    let quickShopSend = {
      items: [{
        id: varId,
        quantity: 1
      }],
      sections: cartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    // Surfaces with no derivable origin (homepage, article pages) send no property at all.
    if (quickShopSource) {
      quickShopSend.items[0].properties = { '_quick_shop': quickShopSource };
    }
    let response = await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(quickShopSend)
    })
    if(!response.ok) {
      throw new Error(`Something is up! Status: ${response.status}`);
    }
    else {
      if (window.matchMedia("(max-width: 768px)").matches) {
        const mobileOptionsContainer = document.querySelector('.options-container.active');
        const optionsBtn = document.querySelector('.options-container button.close-options');
        if(!!optionsBtn) {
          mobileOptionsContainer.remove();
        }
      }
      updateShippingThreshold();
      window.scrollTo(0, 0);
      const cartNotification = document.getElementById('cart-notification');
      cartNotification.focus();
      cartNotification.classList.add('active');
      let notEmptyCart = document.getElementById('shopify-section-mini-cart');
      notEmptyCart.querySelector('.mini-cart-container').classList.add('not-empty');
      const parsedState = await response.json();
      await updateCartSections(parsedState);
    }
  }

  async function updateCartSections(parsedState) {
    cartSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id) ? document.getElementById(section.id).querySelector(section.selector) : null;
      if (elementToReplace) {
        const innerHTMLValue = findCollectionSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (innerHTMLValue) {
            elementToReplace.innerHTML = innerHTMLValue;
        } else {
            console.warn(`No innerHTML value found for selector ${section.selector}`);
        }
      } else {
        console.warn(`Element not found for id: ${section.id}`);
      }
    })
    updateCartHeaderFooter();
  }

  function findCollectionSectionInnerHTML(html, selector) {
    if (!html) return null;
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedDocument.querySelector(selector);
    return element ? element.innerHTML : null;
  }
  
  function cartSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
  
  container.append(...optionGroups);

  return container;
}
